module.exports = __webpack_public_path__ + "static/media/funan_2.9f02ab76.jpg";